import React from 'react';
import { Outlet } from 'react-router-dom';

const WarehouseOutlet = () => {
  return (
    <>
        <Outlet />
    </>
  )
}

export default WarehouseOutlet
